import React from 'react';
import { DownloadIcon, SearchIcon, CheckIcon } from 'lucide-react';
import { MOCKUP_URL } from '../../data/offer';
import { LazyImage } from '../LazyImage';
import { CtaButton } from '../CtaButton';
const steps = [{
  title: 'Lo descargás',
  text: 'Acceso inmediato después de la compra.',
  icon: DownloadIcon
}, {
  title: 'Buscás tu sesión o ficha',
  text: 'Según la temática que vas a trabajar.',
  icon: SearchIcon
}, {
  title: 'Y listo',
  text: 'Lo usás y adaptás en tu consulta.',
  icon: CheckIcon
}];
export function ValueStackSection() {
  return <section className="bg-beige-100 py-10 sm:py-16" data-id="element-407" data-mp="2adddf8efmls6">
      <div className="mx-auto grid max-w-6xl items-center gap-6 px-5 sm:px-8 lg:grid-cols-[320px_1fr] lg:gap-12" data-id="element-408" data-mp="2f77us56keoo3">
        <LazyImage src={MOCKUP_URL} width={1254} height={1254} alt="Kit Sexualidad Práctica" className="mx-auto hidden w-full max-w-[320px] mix-blend-multiply lg:block" data-id="element-409" data-mp="2k3ydl09r7yd7" />
        <div data-id="element-410" data-mp="2t3v12ykeqr6o">
          <h2 className="text-center font-serif text-[1.9rem] leading-tight text-petrol-800 sm:text-5xl lg:text-left" data-id="element-411" data-mp="3hgxpy11aqi5m">
            Ganá <span className="italic text-terra-500" data-id="element-412" data-mp="3chl2pf6ij92i">más tiempo.</span>
          </h2>

          <ol className="mt-5 grid grid-cols-3 gap-2 sm:mt-8 sm:gap-4" data-id="element-413" data-mp="37ihujlv8kmqb">
            {steps.map(({
            title,
            text,
            icon: Icon
          }, i) => <li key={title} className="relative flex flex-col items-center rounded-2xl bg-paper px-2 py-4 text-center sm:items-start sm:px-5 sm:py-5 sm:text-left" data-id="element-414" data-mp="32kyhuqe6si0h" data-mpi={i}>
                <span className={`flex h-9 w-9 items-center justify-center rounded-full sm:h-10 sm:w-10 ${i === 2 ? 'bg-terra-500 text-cream' : 'bg-petrol-800 text-gold-300'}`} data-id="element-415" data-mp="3v7spuntthox2">
                  <Icon className="h-4 w-4" aria-hidden="true" data-id="element-416" data-mp="3li97dja0nx2q" />
                </span>
                <p className="mt-2.5 font-serif text-[15px] leading-tight text-petrol-800 sm:mt-3 sm:text-xl" data-id="element-417" data-mp="mu3k9avsycps">{title}</p>
                <p className="mt-1 hidden text-sm leading-snug text-ink/65 sm:block" data-id="element-418" data-mp="hzpnp55elzjj">{text}</p>
              </li>)}
          </ol>

          <div className="mt-6 flex justify-center sm:mt-8 lg:justify-start" data-id="element-419" data-mp="2h90o9s9mitti">
            <CtaButton className="w-full sm:w-auto" data-id="element-420" data-mp="22k4iy2yybuwl" />
          </div>
        </div>
      </div>
    </section>;
}